import { CheckCircleIcon, WarningIcon } from '@phosphor-icons/react';
import { Spinner } from '@/components/Spinner';
import { ConnectionStatus } from '@/types/camera';

interface CameraStatusBadgeProps {
    status?: ConnectionStatus;
    live?: boolean;
    loading?: boolean;
    stale?: boolean;
}

export function CameraStatusBadge({
    status,
    live,
    loading,
    stale,
}: CameraStatusBadgeProps) {
    if (loading) {
        return <Spinner size={16} variant="light" />;
    }

    const successClass = stale
        ? 'w-4 h-4 text-success-100/40 flex-shrink-0'
        : 'w-4 h-4 text-success-100 flex-shrink-0';
    const warningClass = stale
        ? 'w-4 h-4 text-warning-100 opacity-40 flex-shrink-0'
        : 'w-4 h-4 text-warning-100 flex-shrink-0';

    if (status) {
        const showSuccessIcon = status === ConnectionStatus.SUCCESS;
        const showErrorIcon = status === ConnectionStatus.ERROR;

        return (
            <>
                {showSuccessIcon && (
                    <CheckCircleIcon className={successClass} />
                )}
                {showErrorIcon && <WarningIcon className={warningClass} />}
            </>
        );
    }

    if (live !== undefined) {
        return (
            <>
                {live && <CheckCircleIcon className={successClass} />}
                {!live && <WarningIcon className={warningClass} />}
            </>
        );
    }

    return null;
}
